export const C = {
  blue: '#1D4ED8',
  blueL: '#EFF6FF',
  green: '#16A34A',
  greenL: '#F0FDF4',
  amber: '#D97706',
  amberL: '#FFFBEB',
  rose: '#DB2777',
  roseL: '#FFF1F6',
  navy: '#1E293B',
  gray: '#64748B',
  grayL: '#94A3B8',
  border: '#E2E8F0',
  card: '#FFFFFF',
  bg: '#F8FAFC',
};

export const API_URL =
  'https://superfit-backend-production' +
  '.up.railway.app/v1';
